import type { IconProps } from './IconProps';

export const SmallDotIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 3 4"
    fill="none"
    width={props.width ?? 3}
    height={props.height ?? 4}
    {...props}
  >
    <circle cx="1.5" cy="2" r="1.5" fill="currentColor" />
  </svg>
);
